const weeklyReports = [
  {
    path: '/weekly-reports',
    component: () => import('../pages/main.vue'),
    meta: { role: [3] },
    children: [
      { path: '', component: () => import('../views/weekly-reports/index.vue'), meta: { role: [3] } },
    ],
  },
];

export default weeklyReports;